import { useResultsStore } from './storePinia/stores/results';
import ESputnik from './utils/Analytics/ESputnik/ESputnik';
import axios from 'axios';

__webpack_public_path__ = window.resourceCdnDistUrl
  ? `${window.resourceCdnDistUrl}/`
  : '/local/templates/sova/dist/';
console.log(process.env.NODE_ENV);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// axios >= 1: require() and import resolve to different builds (cjs/esm), so use import
// to keep a single instance with shared defaults for window.axios and `import axios from 'axios'`
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
window.axios.defaults.transformRequest = function (data, headers) {
  try {
    if (data) {
      const resultsStore = useResultsStore();
      const lang = resultsStore.getRequestLang;
      const langName = Object.keys(lang)[0];

      if (data instanceof FormData === false) {
        const formData = new FormData();

        /** if language id is missing It'll be added * */
        if (!data[langName]) {
          data[langName] = lang[langName];
        }

        Object.entries(data).forEach(([key, value]) => {
          if (typeof value === 'object') {
            // create multidimensional array
            for (const i in value) {
              formData.append(`${key}[${i}]`, value[i] || null);
            }
          } else if (value instanceof File) {
            // add file type
            formData.append(key, value, value.name);
          } else {
            formData.append(key, value);
          }
        });
        return formData;
      }
      if (data instanceof FormData === true) {
        /** if language id is missing It'll be added * */
        if (!data.get(langName)) {
          data.set(langName, lang[langName]);
        }
      }
    }
    return data;
  } catch (err) {
    console.error(err);
  }
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// window.$ = window.jQuery = require('jquery');
window.App = require('./libs/App').default;

window.dataLayer = window.dataLayer || [];

if ('requestIdleCallback' in window) {
  requestIdleCallback(
    () => {
      ESputnik.init();
    },
    { timeout: 2000 }
  );
} else {
  setTimeout(() => {
    ESputnik.init();
  }, 800);
}
